export default {
  satisfactionGuaranteed: "Satisfaction Guaranteed",
  satisfactionGuaranteedSub: "Love it or get your money back!",
  testimonialOne: '"Easy to use, and very helpful!"',
  testimonialTwo:
    '"Glad to be able to talk to someone who understands me and my culture. Great experience!"',
  testimonialThree:
    '"Sevelyn was great to work with. My provider helped me better understand why I was feeling the way I was and work through my current symptoms. I highly recommend this service!"',
};
